import Home from 'components/Home/Home';
import MainLandingPage from 'features/LandingPage/MainLandingPage';
import { ScheduleViewPage } from 'features/ScheduleView';

export const getHomeComponent = ({
  homeComponent,
  newLandingPageEnabled,
  isV2OrV3Brand,
}: {
  homeComponent?: string;
  newLandingPageEnabled?: boolean;
  isV2OrV3Brand?: boolean;
}) => {
  if (homeComponent === 'calendar') {
    return ScheduleViewPage;
  }

  if (
    typeof newLandingPageEnabled === 'undefined' ||
    typeof isV2OrV3Brand === 'undefined'
  ) {
    return null;
  }

  if (isV2OrV3Brand && newLandingPageEnabled) {
    return MainLandingPage;
  }

  return Home;
};
